/* Rincón Educativo · menú, cajón del celular y "Agregar" sin salir de la página (abre el carrito lateral) */
(function () {
  function iniciar() {
    var cajon = document.querySelector('[data-rc-cajon]');
    var velo = document.querySelector('[data-rc-velo]');
    var ham = document.querySelector('[data-rc-abrir]');

    function abrir() { if (!cajon) return; cajon.hidden = false; velo.hidden = false; ham.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; }
    function cerrar() { if (!cajon) return; cajon.hidden = true; velo.hidden = true; ham.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; }
    if (ham) ham.addEventListener('click', abrir);
    document.querySelectorAll('[data-rc-cerrar]').forEach(function (b) { b.addEventListener('click', cerrar); });
    if (velo) velo.addEventListener('click', cerrar);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { cerrar(); cerrarMegas(); } });

    // Mega menú: en pantallas táctiles el primer toque abre el panel en vez de navegar.
    var items = document.querySelectorAll('.rc-item');
    function cerrarMegas(salvo) { items.forEach(function (i) { if (i !== salvo) i.classList.remove('abierto'); }); }
    items.forEach(function (item) {
      var link = item.querySelector('.rc-nav-link');
      if (!item.querySelector('.rc-mega') || !link) return;
      link.addEventListener('click', function (e) {
        var tactil = window.matchMedia('(hover: none)').matches;
        if (tactil && !item.classList.contains('abierto')) { e.preventDefault(); cerrarMegas(item); item.classList.add('abierto'); }
      });
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.rc-item')) cerrarMegas(); });

    // Subzonas sin material: Shopify redirige /collections/x/etiqueta-inexistente a /collections/x y mostraría
    // toda la colección. Recordamos qué subzona se pidió al hacer clic y mostramos el aviso de «en preparación».
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href*="/collections/"]');
      if (!a) return;
      try {
        var partes = new URL(a.href, location.origin).pathname.split('/').filter(Boolean);
        if (partes.length >= 3) sessionStorage.setItem('rcZona', JSON.stringify({ col: partes[1], tag: partes[2], nombre: a.textContent.replace('→', '').trim() }));
        else sessionStorage.removeItem('rcZona');
      } catch (err) {}
    });
    try {
      var pedida = JSON.parse(sessionStorage.getItem('rcZona') || 'null');
      sessionStorage.removeItem('rcZona');
      var actual = location.pathname.split('/').filter(Boolean);
      var vacioJs = document.querySelector('[data-rc-vacio-js]');
      if (pedida && vacioJs && actual[0] === 'collections' && actual[1] === pedida.col && actual.length === 2) {
        var grilla = document.querySelector('[data-rc-grilla]');
        if (grilla) grilla.hidden = true;
        document.querySelectorAll('.rc-paginas, .rc-cuenta').forEach(function (x) { x.hidden = true; });
        document.querySelectorAll('.rc-vacio:not([data-rc-vacio-js])').forEach(function (x) { x.hidden = true; });
        // Las fechas (etiqueta fecha-MM-DD) se nombran «12 de Octubre» y no «12/10» (texto del chip) ni vacío (el banner del 12/10 es una imagen sin texto).
        var nombre = pedida.nombre;
        var mf = /^fecha-(\d\d)-(\d\d)$/.exec(pedida.tag || '');
        if (mf) nombre = (+mf[2]) + ' de ' + ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'][+mf[1] - 1];
        if (!nombre) nombre = 'esta sección';
        var titulo = document.querySelector('[data-rc-titulo]');
        if (titulo) titulo.textContent = nombre;
        vacioJs.querySelector('[data-rc-nombre]').textContent = nombre;
        vacioJs.hidden = false;
        document.querySelectorAll('.rc-subnav a').forEach(function (x) {
          x.classList.toggle('on', x.getAttribute('href').split('/').filter(Boolean)[2] === pedida.tag);
        });
      }
    } catch (err) {}

    // Carrito lateral (cart drawer de Dawn, cargado por rincon-cabecera). Si no está, se usa el aviso y /cart como respaldo.
    var toast = document.querySelector('[data-rc-toast]');
    var timer;
    function drawer() { var d = document.querySelector('cart-drawer'); return d && typeof d.open === 'function' ? d : null; }
    function actualizarContador() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('.rc-cart-count').forEach(function (c) { c.textContent = cart.item_count; c.classList.toggle('cero', cart.item_count === 0); });
        return cart;
      });
    }
    // El icono del carrito del encabezado abre el cajón en vez de ir a /cart.
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-rc-carro]');
      var d = drawer();
      if (!a || !d) return;
      e.preventDefault();
      d.open(a);
    });
    // Si el cliente cambia cantidades o saca algo desde el cajón, el contador del encabezado se actualiza.
    try {
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.cartUpdate, function () { actualizarContador().catch(function () {}); });
    } catch (err) {}

    // Agregar al carrito (tarjetas y ficha): /cart/add.js, contador al día y cajón abierto con el producto.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rc-agregar]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var texto = btn.getAttribute('data-rc-texto') || btn.textContent;
      btn.setAttribute('data-rc-texto', texto);
      btn.disabled = true; btn.textContent = '...';
      var d = drawer();
      var cuerpo = { id: Number(btn.getAttribute('data-rc-agregar')), quantity: 1 };
      if (d) { cuerpo.sections = 'cart-drawer,cart-icon-bubble'; cuerpo.sections_url = window.location.pathname.charAt(0) === '/' ? window.location.pathname : '/'; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(cuerpo) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function (estado) {
          return actualizarContador().then(function () {
            btn.textContent = '✓ Listo';
            if (d && estado.sections) { d.classList.remove('is-empty'); d.renderContents(estado); }
            else if (toast) { toast.hidden = false; clearTimeout(timer); timer = setTimeout(function () { toast.hidden = true; }, 3500); }
            setTimeout(function () { btn.textContent = texto; btn.disabled = false; }, 1600);
          });
        })
        .catch(function () {
          btn.textContent = 'Reintentar'; btn.disabled = false;
          setTimeout(function () { btn.textContent = texto; }, 2500);
        });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
